import { asyncMac, makeAsyncTypes, makeFetchingReducer } from "../utils";
import { toast } from 'react-toastify';
import { API_PROVEEDORES } from "../../views/MainLayout/components/shared/services/proveedores";

const initialProveedor = {
    proveedor: {},
    ventas: [],
    devoluciones: [],
    presupuestos: [],
    metricas: []
};

export const proveedorReducer = (state = initialProveedor, action) => {
    switch(action.type){
        case "ficha-proveedor/fullfilled": {
            return action.payload;
        }
        case "ficha-proveedor/clear": {
            return initialProveedor;
        }
        case "metricas-proveedor/fullfilled": {
            return {...state, metricas: action.payload}
        }
        default:
            return state
    }
}

const asyncProveedor = makeAsyncTypes('ficha-proveedor');
const asyncProveedorMetricas = makeAsyncTypes('metricas-proveedor');

const [setPending, setFullFilled, setError ] = asyncMac(asyncProveedor);
const [setPendingM, setFullFilledM, setErrorM ] = asyncMac(asyncProveedorMetricas);

export const fichaProveedorFetchingReducer = makeFetchingReducer([
    'ficha-proveedor/pending', 
    'ficha-proveedor/fullfilled', 
    'ficha-proveedor/rejected'
]);

export const fetchFichaProveedor = (section, page, proveedorId) => async dispatch => {
    dispatch(setPending());

    try {
        const response = await API_PROVEEDORES.getProveedorFicha(section, null, page, proveedorId)
        const data = await response.data;
        dispatch(setFullFilled(data));
    } catch (e) {
        toast.error(e.message)
        dispatch(setError(e.message))
    }
}

export const fetchMetricasProveedor = (proveedorId, startDate, endDate, view) => async dispatch => {
    dispatch(setPendingM());
    let query = 'start_date=' + startDate
      + '&end_date=' + endDate
      + '&view=' + view;

    try {
        const response = await API_PROVEEDORES.getProveedorFicha('metricas', query, 1, proveedorId)
        const data = await response.data;
        dispatch(setFullFilledM(data));
    } catch (e) {
        toast.error(e.message)
        dispatch(setErrorM(e.message))
    }
}

export const editProveedor = (proveedorId) => async dispatch => {
    dispatch(setPending());

    try {
        const response = await API_PROVEEDORES.updateProveedor(proveedorId)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilled(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        toast.error(e.message)
        dispatch(setError(e.message))
    }
}

export const fichaProveedorReducer = proveedorReducer;
export const fichaProveedorStatusReducer = fichaProveedorFetchingReducer;